import { StageEvent } from '../../message/index';
import * as CubeTree from '../../cubeTree/index';
import Store from './store/index';
import Utils from '../../utils/util';

function panelSelect(): void {
    let allSelected: Array<CubeId> = Store.getAll();

    StageEvent.fire('selectCubes', {
        eventFrom: 'stage',
        cubes: CubeTree.findByCubeIds(allSelected)
    });
}

const panelSelectAsync = Utils.debounce(panelSelect, 100);
const panelSelectSync = panelSelect;

export {
    panelSelectAsync,
    panelSelectSync
}

export default {
    panelSelectAsync,
    panelSelectSync
}
